






























































import Vue from 'vue'
export default Vue.extend({
    props: {
        loader: {
            type: Boolean,
            default: false
        }
    }
})
